module.exports = __webpack_public_path__ + "img/teammodel_title_en.c4d8a10b.png";